import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Icons from "../../utils/icons";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import api from "../../api/api";
import { MyContext } from "../../Components/Context";
import Confirm from "../../Components/Modal/Alert/confirm";
import ReactQuill from "react-quill";

export default function DetailsPlainte({ type = 'res' }) {
    
    const navigate = useNavigate();
    const [detailPlainte, setDetailPlainte] = useState(null);
    const [showAlert, setShowAlert] = useState(null);
    const { id } = useParams();
    const { actifItem, setActifItem } = useContext(MyContext);



    const [body, setBody] = useState(null)

    useEffect(() => {
        const getDetail = async () => {
            try {
                const response = await api.get('/detailPlainte', {
                    params: { id }
                });
                setDetailPlainte(response.data);
                setActifItem('Plaintes')                
            } catch (error) {
                console.error(error);
            }
        };
        getDetail();
    }, [id]);


    const reply = async ()=>{


        try{

            if(body){
                
                const resp = await api.post('/plaintes/reply', {
                    
                    title : detailPlainte.title,
                    body : body,
                    email : detailPlainte.client.email,
                    plainteId : detailPlainte.id
                    
                })
            }
            
            window.location.reload();


            alert('Mail envoyer')

            
        }catch(e){

            alert('Erreur')
        }
    }

    

    return detailPlainte ? (
        <div className="flex items-center justify-center min-h-screen py-10 "> 
            <div className="col-span-8 p-10 mx-10 bg-white rounded-lg shadow-xl max-lg:col-span-12 dark:bg-gray-800">
                <div className="p-8 m-auto border-2 border-gray-600 rounded-lg shadow-sm dark:bg-gray-700">
                    <div className="flex items-center justify-between">
                        <h2 className="mb-4 text-2xl font-bold text-gray-800">
                            <span className="text-purple-600">{detailPlainte.title}</span>
                        </h2>
                        <p className="px-4 py-1 text-sm font-bold text-purple-500 bg-purple-600 rounded-full bg-opacity-10">
                            {detailPlainte.type === 'RSV' ? 'Reservation' : 'Requetes'}
                        </p>
                    </div>

                    <div className="mb-8 space-y-3">
                        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                            ClientId : 
                            <span 
                                className="mx-2 font-normal text-purple-600 transition-all cursor-pointer hover:underline hover:font-bold"
                                onClick={() => navigate(`/client/details/${detailPlainte.clientId}`)}
                            >
                                {detailPlainte.clientId}
                            </span>
                        </h3>

                        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                            Nom et Prénoms : 
                            <span className="mx-2 font-normal text-gray-600 dark:text-gray-200">{detailPlainte.client.lastname} {detailPlainte.client.firstname}</span>
                        </h3>

                        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                            Pays : <span className="mx-2 font-normal text-gray-600 dark:text-gray-200">{detailPlainte.client.country}</span>
                        </h3>

                        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                            Ville : <span className="mx-2 font-normal text-gray-600 dark:text-gray-200">{detailPlainte.client.city}</span>
                        </h3>

                        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                            ID de la plainte : 
                            <span className="mx-2 font-normal text-gray-600 dark:text-gray-200">{detailPlainte.id}</span>
                        </h3>

                        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                            État de la plainte : 
                            <span className={`font-normal  mx-2 py-1 px-2 bg-opacity-10 rounded-full ${detailPlainte.isOpen ? 'text-green-600 bg-green-600' : 'text-red-600 bg-red-600'}`}>{detailPlainte.isOpen ? 'Ouverte' : 'Fermée'}</span>
                        </h3>

                        <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                            ReservationId : 
                            <span 
                                className="font-normal text-purple-600 transition-all cursor-pointer hover:underline hover:font-bold"
                                onClick={() => navigate(`/reservation/details/${detailPlainte.reservationId}`)}
                            >
                                {detailPlainte.reservationId}
                            </span>
                        </h3>

                        {detailPlainte.type === 'RSV' && 
                            (<h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                                AnnonceId : 
                                <span 
                                    className="font-normal text-purple-600 transition-all cursor-pointer hover:underline hover:font-bold"
                                    onClick={() => navigate(`/annonce/details/${detailPlainte.reservation.annonceId}`)}
                                >
                                    {detailPlainte.reservation.annonceId}
                                </span>
                            </h3>)
                        }
                    </div>

                    <div className="py-4 font-bold text-gray-800">
                        <FontAwesomeIcon icon={Icons.calendar} className="text-purple-600" />
                        <span className="px-4 text-sm font-bold text-purple-800">
                            {new Date(detailPlainte.createdAt).toLocaleDateString()}
                        </span>
                    </div>
                </div>

                <div className="p-6 mt-6 border-2 border-gray-600 shadow-sm rounded-xl bg-gray-50 dark:bg-gray-700">
                    <p className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                        Contenu : 
                        <span className="font-normal text-gray-600 dark:text-gray-200">{detailPlainte.contenu}</span>
                    </p>

                    <div className="flex items-center justify-between pt-4">
                        <div className="font-bold text-gray-800">
                            <FontAwesomeIcon icon={Icons.clip} className="text-purple-600" />
                            {detailPlainte.type === 'RSV' && (
                                <span
                                    onClick={() => navigate(`/reservation/details/${detailPlainte.reservation.id}`)}
                                    className="ml-2 text-purple-800 cursor-pointer hover:underline hover:text-purple-900"
                                >
                                    {detailPlainte.reservation.id}
                                </span>
                            )}
                        </div>

                        <span>
                            {detailPlainte.state === 'PROCESSING' && 
                                <span className="px-3 py-2 text-sm text-white bg-green-600 rounded-lg shadow-md cursor-pointer hover:bg-green-700">
                                    Resolue
                                    <FontAwesomeIcon icon={Icons.check} className="ml-2" />
                                </span>
                            }

                            <span className="px-3 py-2 ml-2 text-sm font-bold text-green-700 bg-green-600 rounded-xl bg-opacity-10">
                                {detailPlainte.state}
                            </span>
                        </span>
                    </div>

                    <div className="grid grid-cols-3 gap-4 mt-10">
                        {detailPlainte.piece.split(';').filter(item => item !== '').map((item, idx) => (
                            <img 
                                alt={`piece-${item}`} 
                                src={`${process.env.REACT_APP_API_PICTURE_URL}${item}`} 
                                className="transition-shadow rounded-lg shadow-md cursor-pointer hover:shadow-lg hover:bg-gray-100"
                                onClick={()=>{
                                    navigate('/preview', { 
                                                            state: { 
                                                                        images : detailPlainte.piece
                                                                                .split(';')
                                                                                .filter(item => item !== '')
                                                                                .map(item => `${process.env.REACT_APP_API_PICTURE_URL}${item}`), 
                                                                        currentIndex: idx 
                                                                    } 
                                                        }
                                            );
                                }} 
                            />
                        ))}
                    </div>
                </div>

                <div className="mt-8">
                    <textarea
                        type="text"
                        className="w-full h-40 p-4 mt-4 border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-purple-600 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
                        placeholder="Saisissez votre réponse ici..."
                        onChange={(event) => setBody(event.target.value)}
                    />

                    {/* <ReactQuill 
                        placeholder="Saisissez votre réponse ici..." 
                        theme="snow" 
                        value={body} 
                        onChange={setBody} 
                        className="w-full h-40 p-4 mt-4 border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-purple-600 dark:text-gray-200 dark:bg-gray-700 dark:border-gray-600"
                    /> */}
                    
                    <div 
                        onClick={async () =>setShowAlert(true)}
                        className="w-40 p-2 my-4 text-center text-white bg-purple-700 rounded-lg shadow cursor-pointer hover:bg-purple-800 active:ring-4 active:ring-purple-300"
                    >
                        Envoyer
                    </div>
                </div>
            </div>

            <Confirm
                open={showAlert}
                onAccept={reply}
                onDecline={()=>setShowAlert(false)}
                onClose={()=>setShowAlert(false)}
            />
        </div>

    ) : null;
}
